export default __webpack_public_path__ + "navigation-camera-bearing-smoothing-disabled-1200-52ce49ecb6d450e4ca38ba349ee08b37.png";